// extracted by mini-css-extract-plugin
export default {"dialog":"dialog__Modal__cyCNQ","contentWrapper":"contentWrapper__Modal__cyCNQ","close":"close__Modal__cyCNQ"};